import { useHttpStore } from "@/stores/http/index.ts";
import useScrollPersistence from "@/v2/shared/useScrollPersistence.js";
import { useStore } from "vuex";
import useCMSData from "@/components/CMSComponents/useCMSData.js";

let hasAlreadyAttemptedToLoadUser = false;

async function afterEach(to) {
  const store = useStore();
  const { loadCMSData } = useCMSData();
  const httpStore = useHttpStore();
  const { handleAfterEachRouteChange } = useScrollPersistence();

  handleAfterEachRouteChange(to);

  store.commit("setRoutePending", false);

  if (["NotFound404", "Login", "Redirect"].includes(to.name)) {
    return;
  }

  if (!store.getters.getUserEmail && !hasAlreadyAttemptedToLoadUser) {
    await httpStore.loadToken();
    await store.dispatch("api/fetchUser");
    hasAlreadyAttemptedToLoadUser = true;
  }

  if (store.getters.isAuth) {
    await loadCMSData(to);
  }
}

export { afterEach };
